import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full bg-cream py-16 md:py-24" data-id="element-257">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-259">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-navy mb-6 text-center" data-id="element-260">
            ¿Oras… pero por dentro sigues igual?
          </h2>

          <div className="prose prose-lg max-w-none mb-8" data-id="element-261">
            <p className="text-dark/80 leading-relaxed mb-4" data-id="element-262">
              Muchos creyentes oran con fe, pero viven con el estómago apretado.
              Piden provisión, pero el miedo al dinero no desaparece. Declaran
              paz, pero la mente sigue acelerada.
            </p>
            <p className="text-dark/80 leading-relaxed mb-8" data-id="element-263">
              No es falta de fe. Es que nadie te enseñó a{' '}
              <strong data-id="element-264">alinear tu interior</strong> con lo que declaras por
              fuera. Y desde ese estado dividido, es difícil recibir con paz,
              decidir con claridad y avanzar con constancia.
            </p>
          </div>

          <blockquote className="border-l-4 border-gold pl-6 py-4 mb-12 bg-white/50 rounded-r-lg" data-id="element-265">
            <p className="italic text-lg md:text-xl font-serif text-navy mb-2" data-id="element-266">
              "No os conforméis a este siglo, sino transformaos por medio de la
              renovación de vuestro entendimiento."
            </p>
            <cite className="text-gold font-semibold not-italic" data-id="element-267">
              Romanos 12:2 (RVR60)
            </cite>
          </blockquote>

          <h3 className="text-2xl font-serif font-bold text-navy mb-6" data-id="element-268">
            ¿Te identificas con alguno de estos?
          </h3>

          <div className="space-y-4 mb-8" data-id="element-269">
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-270">
              <span className="text-2xl" data-id="element-271">😔</span>
              <p className="text-dark/80" data-id="element-272">
                Oras, pero terminas más agitado(a) que cuando empezaste
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-273">
              <span className="text-2xl" data-id="element-274">💸</span>
              <p className="text-dark/80" data-id="element-275">
                La ansiedad por el dinero no desaparece aunque confíes en Dios
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-276">
              <span className="text-2xl" data-id="element-277">🔄</span>
              <p className="text-dark/80" data-id="element-278">
                Empiezas con entusiasmo espiritual, pero a los días vuelves al
                mismo punto
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-279">
              <span className="text-2xl" data-id="element-280">🧠</span>
              <p className="text-dark/80" data-id="element-281">
                Tu mente no para: deudas, pendientes, "qué pasará si…"
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-282">
              <span className="text-2xl" data-id="element-283">😓</span>
              <p className="text-dark/80" data-id="element-284">
                Sientes que Dios bendice a otros, pero en tu caso algo no
                termina de fluir
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-285">
              <span className="text-2xl" data-id="element-286">🚪</span>
              <p className="text-dark/80" data-id="element-287">
                Ves puertas cerradas aunque haces lo correcto
              </p>
            </div>
            <div className="flex items-start gap-3 bg-white p-4 rounded-lg shadow-sm" data-id="element-288">
              <span className="text-2xl" data-id="element-289">😶</span>
              <p className="text-dark/80" data-id="element-290">
                Ya intentaste afirmaciones, devocionales, ayunos… y el desorden
                interior sigue
              </p>
            </div>
          </div>

          <p className="text-center text-lg font-semibold text-navy" data-id="element-291">
            Si marcaste aunque sea uno: este programa fue creado para ti.
          </p>
        </motion.div>
      </div>
    </section>;
}